export default "__VITE_ASSET__CE9dS4dn__"